module.exports = __webpack_public_path__ + "static/img/title.6953638.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/loacker/title.jpg
// module id = 421
// module chunks = 1